<template>
    <div>
        <div class="tpl-category">
            <el-button class="category-name" :class="categoryCls(item.id)" v-for="(item,index) in tplCategoryList"
                       :key="index"
                       @click="search(item.id)">{{item.title}}
            </el-button>
        </div>
        <div class="tpl-list">
            <div class="item" v-for="(item,index) in tplList" :key="index">
                <div class="tpl-img">
                    <img :src="item.cover_image" alt="" width="100%">
                    <div class="hover">
                        <img :src="item.qrcode_url" :id="'qrcode-url-' + index"
                             alt="" class="qr">
                        <span class="tip">微信扫一扫预览</span>
                        <el-button size="small" class="btn" type="primary" @click="selectTpl(item)" plain>立即使用</el-button>
                    </div>
                </div>
                <div class="info">
                    <span class="category-name">{{item.category_name}}</span>
                    <span class="tpl-name">{{item.name}}</span>
                </div>
            </div>
        </div>
        <div v-if="tplList" class="pagination-wrapper">
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="count"
                    layout="total, prev, pager, next"
                    :total="totalNumber">
            </el-pagination>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .tpl-category {
        display: flex;
        flex-wrap: wrap;
        padding: 24px 14px 0 24px;
        .category-name {
            flex: 0 0 76px;
            height: 40px;
            margin: 0 16px 16px 0;
            &.active {
                border: 1px solid #4A8EF7;
                color: #4A8EF7;
            }
        }
    }

    .tpl-list {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 0 0 24px;
        min-height: 500px;
        .item {
            flex: 0 0 138px;
            margin: 0 14px 16px 0;
            .tpl-img {
                position: relative;
                border: 1px solid #DCDFE6;
                min-height: 242px;
                cursor: pointer;
                .hover {
                    display: none;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    .tip {
                        font-size: 13px;
                    }
                    .qr {
                        display: block;
                        width: 90%;
                        margin: 20px auto 12px;
                    }
                }
                &:hover {
                    .hover {
                        display: block;
                        background: #FFF;
                        text-align: center;
                        .btn {
                            margin-top: 16px;
                            background: #FFFFFF;
                            border: 1px solid #4A8EF7;
                            &:hover {
                                background: #4A8EF7;
                                color: #FFFFFF;
                            }
                        }
                    }
                }
            }
            .info {
                font-size: 0;
                padding-top: 12px;
                .category-name {
                    width: 34px;
                    height: 20px;
                    background: #4A8EF7;
                    border: 1px solid #4A8EF7;
                    border-radius: 2px;
                    display: inline-block;
                    vertical-align: middle;
                    color: #FFFFFF;
                    font-size: 12px;
                    text-align: center;
                }
                .tpl-name {
                    display: inline-block;
                    padding-left: 5px;
                    color: #666666;
                    font-size: 12px;
                    vertical-align: middle;
                    white-space: nowrap;
                    width: 100px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
</style>

<script>

  export default {
    data() {
      return {
        tplCategoryList: [],
        tplList: [],
        category_id: '',
        qrcode_url: '',
        offset: 0,
        count: 12,
        totalNumber: 0,
        currentPage: 1
      }
    },

    computed: {},

    components: {},

    created() {
      this.requestTplCategory();
      this.requestTpl();
    },

    mounted() {

    },

    methods: {
      // 获取模版分类
      requestTplCategory() {
        lib.api.get({
          api: 'wdzg/b/cms/category/list',
          data: {
            offset: 0,
            count: 20
          },
          success: (data) => {
            this.tplCategoryList = data.data.category_list;
            if (this.tplCategoryList.length > 0) {
              this.tplCategoryList.unshift({
                title: '全部',
                id: ''
              })
            }
          },
          error: (data) => {
            this.$message.error(data.msg || '请求失败!');
          },
          complete: () => {

          }
        })
      },
//      mouseover(id, index) {
//        if (!this.tplList[index].qrcode_url) {
//          this.getPreviewUrl(id, index);
//        }
//      },
      requestTpl() {
        lib.api.get({
          api: 'wdzg/b/cms/page/template/list',
          data: {
            offset: this.offset,
            count: 12,
            category_id: this.category_id
          },
          success: (data) => {
            if(data.data){
              this.tplList = data.data.template_list;
              this.totalNumber = data.data.total_count;
            }

            this.tplList.map((val, index)=>{
              val.qrcode_url = '';
              this.getPreviewUrl(val.id, index)
            })
          },
          error: (data) => {
            this.$message.error(data.msg || '请求失败!');
          },
          complete: () => {

          }
        })
      },
      // 获得预览二维码
      getPreviewUrl(id, index) {
        lib.api.get({
          api: "wdzg/b/cms/page/preview_url/get",
          data: {
            id: id
          },
          success: (data) => {
            if(this.tplList[index] && data.data) {
              this.tplList[index].qrcode_url = data.data.preview_url;
              let el = document.getElementById('qrcode-url-' + index);
              if(el){
                el.src = data.data.preview_url;
              }
            }
          },
          error: function () {
//            this.$message.error(data.msg);
          },
          complete: function (data) {
          }
        });
      },
      categoryCls(id) {
        if (this.category_id === id) {
          return 'active';
        }
      },
      selectTpl(item) {
        this.$emit('selectTpl', item);
      },
      search(id) {
        this.category_id = id;
        this.requestTpl();
      },
      handleCurrentChange(val) {
        this.offset = this.count * (val-1) || 0;
        this.requestTpl();
      },
    }
  }

</script>
